module.exports.CometD = require('./lib/CometD')
module.exports.Transports = require('./lib/browser/Transports')
